import React from 'react';
import {
  Heading,
  Link,
  Button,
  ButtonGroup,
  WayPointHandler,
  Paragraph,
} from 'components';
import './ContactBoxes.scss';

const ContactBoxes = () => (
  <WayPointHandler path="contact">
    <div className={'contact-boxes'}>
      <div className={'contact-boxes__item contact-boxes__item--career'}>
        <div className={'contact-boxes__content anim-fade-in-bottom'}>
          <div>
            <div className={'contact-boxes__headline'}>
              <Heading color={'black'} size={'large'} type={3}>
                Join our Team
              </Heading>
              <Paragraph additionalClass={'contact-boxes__description'}>
                {
                  'Here, you’re not “just” a developer or a designer! Take a step forward and join us!'
                }
              </Paragraph>
            </div>
          </div>
          <ButtonGroup>
            <Link to={'/career/'}>
              <Button id={'homepage-career'} color={'white'}>
                Career
              </Button>
            </Link>
          </ButtonGroup>
        </div>
      </div>
      <div className={'contact-boxes__item contact-boxes__item--partner'}>
        <div className={'contact-boxes__content anim-fade-in-bottom'}>
          <div>
            <div className={'contact-boxes__headline'}>
              <Paragraph
                size={'large'}
                color={'black'}
                additionalClass={'text--bold'}
              >
                {"Let's"} talk
              </Paragraph>
              <Paragraph additionalClass={'contact-boxes__description'}>
                {"We'd"} love to help with your product. Get in touch.
              </Paragraph>
            </div>
          </div>
          <ButtonGroup>
            <Link to={'/contact#form'}>
              <Button id={'contact-boxes'} color={'yellow'}>
                Contact
              </Button>
            </Link>
          </ButtonGroup>
        </div>
      </div>
    </div>
  </WayPointHandler>
);

export default ContactBoxes;
